import React, { useContext, useState } from 'react'
import { TicketListManagerContext } from '~/service/TicketListManager'
import classNames from 'classnames'
import { FormattedMessage } from '~/translations/utils'
import Item from './list/Item'
import MainContent from '../MainContent'
import Search from '~/components/common/Search'
import Views from './list/Views'
import useResizeObserver from 'use-resize-observer'
import AddTicket from './list/AddTicket'
import TableHeader from './list/TableHeader'
import Show from './Show'
import { Route, useRouteMatch } from 'react-router-dom'
import { Resizable } from 're-resizable'
import { useStore } from '~/components/tickets/store'
import store from 'store2'

const List: React.FC = ({}) => {
  const { search, filter, setSearch, setFilter, loadHook } = useContext(
    TicketListManagerContext
  )

  const { setColumns, columns } = useStore()
  const { path } = useRouteMatch()
  const ticketShow = useRouteMatch('/tickets/:ticketId')
  const { ref, width = 0 } = useResizeObserver<HTMLElement>()
  const visibleTicketlist =
    (ticketShow && window.innerWidth >= 1100 && columns) || !ticketShow

  loadHook()

  return (
    <>
      <div
        className={classNames('main-header list-header ticket-list-header', {
          'ticket-list-header--large': width > 1100,
        })}
      >
        <Search
          filter={filter}
          setFilter={setFilter}
          search={search}
          setSearch={setSearch}
          small={width > 1100}
        />
        <div className="ticket-list-header-tabs">
          <Views width={width} />
        </div>
        <div
          className={classNames('ticket-list-header-add', {
            'ticket-list-header-add--large': width > 1100,
          })}
        >
          {window.innerWidth >= 1100 && (
            <button
              onClick={() => setColumns(!columns)}
              className={classNames('button is-small', {
                'is-info is-light': columns,
              })}
            >
              <span className="icon is-small">
                <i className="fa-regular fa-table-columns"></i>
              </span>
            </button>
          )}
          <AddTicket />
        </div>
      </div>
      <div className="main-columns" ref={ref}>
        <>{visibleTicketlist && <TicketsList ticketWidth={width} />}</>
        {!ticketShow && columns && window.innerWidth >= 1100 && (
          <div className="main-columns-item main-columns-item--ticket">
            <div className="ticket-show ticket-show--empty">
              <div className="ticket-show-main ticket-show-main--empty">
                <div className="ticket-show-empty">
                  <span className="ticket-show-empty-icon fa-solid fa-envelope"></span>
                  <span className="ticket-show-empty-title">
                    <FormattedMessage id="tickets / show / empty" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
        <Route path={path + ':ticketId'}>
          <div className="main-columns-item main-columns-item--ticket">
            <Show />
          </div>
        </Route>
      </div>
    </>
  )
}

export default List

type Props = {
  ticketWidth: number
}

const TicketsList: React.FC<Props> = ({ ticketWidth }) => {
  const ticketShow = useRouteMatch('/tickets/:ticketId')
  const { tickets, loadMore, loading } = useContext(TicketListManagerContext)
  const { ref, width = 0 } = useResizeObserver<HTMLElement>()
  const [widthTicket, setWidthTicket] = useState<number>(
    !ticketShow
      ? ticketWidth
      : store.has('ticket-width')
      ? store.get('ticket-width')
      : ticketWidth / 2
  )

  return (
    <Resizable
      className={classNames('main-columns-item ', {
        'ticket-lg-list': width >= 900,
      })}
      defaultSize={{
        width: '100%',
        height: '100%',
      }}
      maxWidth={window.innerWidth <= 1100 ? '100%' : window.innerWidth - 600}
      minWidth={450}
      enable={{
        right: true,
      }}
      handleClasses={{
        right: 'main-columns-item-right-handle',
      }}
      size={{
        width: widthTicket,
        height: '100%',
      }}
      onResizeStop={(e, direction, ref, d) => {
        setWidthTicket(widthTicket + d.width)
        store.set('ticket-width', widthTicket + d.width)
      }}
    >
      <div className="ticket-list-table-wrapper-header">
        <TableHeader width={width} />
      </div>
      <MainContent
        className="ticket-list-scroll"
        onScrolledToEnd={() => loadMore()}
      >
        <div className="list ticket-list" ref={ref}>
          {tickets.length ? (
            <div className="list-items list-items--th">
              {tickets.map((ticket, k) => (
                <Item ticket={ticket} key={k} width={width} />
              ))}
            </div>
          ) : (
            !loading && (
              <div className="list-empty">
                <FormattedMessage id="tickets / empty" />
              </div>
            )
          )}
          <div
            className={classNames('list-loading', {
              'is-active': loading,
            })}
          >
            <span className="fa fa-spin fa-spinner-third" />
          </div>
        </div>
      </MainContent>
    </Resizable>
  )
}
